import { ImagePresenter } from "components/common/ImagePresenter";
import { VideoPresenter } from "components/common/VideoPresenter";
import React from "react";
import { ResourceType } from "types/graphqlapi";

import { SpeachBalloon, SpeachBalloonProps } from "../SpeachBalloon";
import { StyledFileSpeechBalloon } from "./styled";
import { ClientChatData } from "components/report/ChatArea/hooks";
import { colors } from "constants/colors";
import {
  StyledMentionedListContainer,
  StyledMentionedSpan,
} from "components/report/Mention/styled";

type FileSpeachBalloonProps = {
  chat: ClientChatData;
  reverse?: boolean;
} & SpeachBalloonProps;

export const FileSpeachBalloon: React.FC<FileSpeachBalloonProps> = ({
  chat,
  reverse,
}) => {
  const getMediaContent = () => {
    switch (chat.file_type) {
      case ResourceType.IMAGE: {
        return (
          <ImagePresenter src={chat.src} maxWidth="20vw" maxHeight="30vh" />
        );
      }
      case ResourceType.VIDEO: {
        return (
          <VideoPresenter
            src={chat.src}
            controls
            maxWidth="20vw"
            maxHeight="30vh"
          />
        );
      }
    }
  };

  return (
    <>
      <StyledFileSpeechBalloon reverse={reverse}>
        {chat.mentionedMonitorList &&
          chat.mentionedMonitorList.length !== 0 && (
            <SpeachBalloon
              background={
                chat.monitor_id
                  ? colors.white
                  : colors.moderatorTextBalloonBackGround
              }
            >
              <StyledMentionedListContainer>
                {chat.mentionedMonitorList.map((mentioned) => (
                  <StyledMentionedSpan key={mentioned.id}>
                    @{mentioned.name}
                  </StyledMentionedSpan>
                ))}
              </StyledMentionedListContainer>
            </SpeachBalloon>
          )}
        {getMediaContent()}
      </StyledFileSpeechBalloon>
    </>
  );
};
